var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-sidebar dark-bg py-3 main mt-5"},[_c('h4',{},[_vm._v("Admin Menu")]),_c('div',{staticClass:"accordian",attrs:{"role":"tablist"}},[_c('ul',{staticClass:"nav flex-column"},[(
          _vm.sidebarModules.some(
            ({ module_action }) => module_action === 'FUNDING'
          )
        )?_c('li',[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle.funding",modifiers:{"funding":true}}],staticClass:"nav-link",attrs:{"href":"#funding #top"}},[_vm._v(" Funding ")]),_c('b-collapse',{attrs:{"id":"funding","accordion":"my-accordion","role":"tabpanel","visible":_vm.isMenuMatched('funding')}},[(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'FundingDashboard'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('fundingDashboard'),
            },attrs:{"to":{
              name: 'FundingDashboard',
              params: { activeMenuItem: 'fundingDashboard' },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Funding Dashboard ")],1):_vm._e()],1),_c('b-collapse',{attrs:{"id":"funding","accordion":"my-accordion","role":"tabpanel","visible":_vm.isMenuMatched('funding')}},[(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'PaymentMethods'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('paymentMethods'),
            },attrs:{"to":{
              name: 'PaymentMethods',
              params: { activeMenuItem: 'paymentMethods' },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Payment Methods ")],1):_vm._e()],1)],1):_vm._e(),(
          _vm.sidebarModules.some(
            ({ module_action }) => module_action === 'DASHBOARD'
          )
        )?_c('li',[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle.dashboard",modifiers:{"dashboard":true}}],staticClass:"nav-link",attrs:{"href":"#dashboard #top"}},[_vm._v(" Dashboards ")]),_c('b-collapse',{attrs:{"id":"dashboard","accordion":"my-accordion","role":"tabpanel","visible":_vm.isMenuMatched('dashboard')}},[(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) => sub_module_action === 'P4P'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{ activeItem: _vm.isMenuItemMatched('dashboardP4p') },attrs:{"to":{ name: 'P4P', params: { activeMenuItem: 'dashboardP4p' } }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" General ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'LoginsOrders'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('dashboardLogin&Orders'),
            },attrs:{"to":{
              name: 'LoginAndOrdersReport',
              params: { activeMenuItem: 'dashboardLogin&Orders' },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Logins & Orders ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'PointsRemaining'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('dashboardPointsRemaining'),
            },attrs:{"to":{
              name: 'PointsRemaining',
              params: { activeMenuItem: 'dashboardPointsRemaining' },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Points Remaining ")],1):_vm._e()],1)],1):_vm._e(),(
          _vm.sidebarModules.some(
            ({ module_action }) => module_action === 'ORDERS'
          )
        )?_c('li',[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle.orders",modifiers:{"orders":true}}],staticClass:"nav-link",attrs:{"href":"#orders #top"}},[_vm._v(" Orders ")]),_c('b-collapse',{attrs:{"id":"orders","accordion":"my-accordion","role":"tabpanel","visible":_vm.isMenuMatched('orders')}},[(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'OrderApproval'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('ordersOrderApproval'),
            },attrs:{"to":{
              name: 'OrderApproval',
              params: { activeMenuItem: 'ordersOrderApproval' },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Order Approval ")],1):_vm._e()],1)],1):_vm._e(),(
          _vm.sidebarModules.some(
            ({ module_action }) => module_action === 'REPORTS'
          )
        )?_c('li',[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle.reports",modifiers:{"reports":true}}],staticClass:"nav-link",attrs:{"href":"#reports #top"}},[_vm._v(" Reports ")]),_c('b-collapse',{attrs:{"id":"reports","visible":_vm.isMenuMatched('reports'),"accordion":"my-accordion","role":"tabpanel"}},[(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'LoginsOrdersReport'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('reportsLogins&OrdersReport'),
            },attrs:{"to":{
              name: 'AdminLoginsAndOrdersReport',
              params: {
                activeMenuItem: 'reportsLogins&OrdersReport',
                activeMenu: 'reports',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Logins & Orders Report ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'TransactionReport'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('reportsTransactionReport'),
            },attrs:{"to":{
              name: 'AdminTransactionReport',
              params: {
                activeMenuItem: 'reportsTransactionReport',
                activeMenu: 'reports',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Transaction Report ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'TaxReportingDatabase'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('reportsTaxReportingDatabase'),
            },attrs:{"to":{
              name: 'TaxReportingDatabase',
              params: {
                activeMenuItem: 'reportsTaxReportingDatabase',
                activeMenu: 'reports',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Tax Reporting Database ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'GenerateExcelReport'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('reportsGenerateExcelReport'),
            },attrs:{"to":{
              name: 'GenerateExcelReport',
              params: {
                activeMenuItem: 'reportsGenerateExcelReport',
                activeMenu: 'reports',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Generate Excel Report ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'GenerateLibertyTaxationReport'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('reportsGenerateTaxationReport'),
            },attrs:{"to":{
              name: 'GenerateTaxationReport',
              params: {
                activeMenuItem: 'reportsGenerateTaxationReport',
                activeMenu: 'reports',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Generate Liberty Taxation Report ")],1):_vm._e()],1)],1):_vm._e(),(
          _vm.sidebarModules.some(
            ({ module_action }) => module_action === 'USERS'
          )
        )?_c('li',[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle.users",modifiers:{"users":true}}],staticClass:"nav-link",attrs:{"href":"#users #top"}},[_vm._v(" Users ")]),_c('b-collapse',{attrs:{"id":"users","visible":_vm.isMenuMatched('users'),"accordion":"my-accordion","role":"tabpanel"}},[(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) => sub_module_action === 'UserManager'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('usersUserManager'),
            },attrs:{"to":{
              name: 'AdminUserManager',
              params: {
                activeMenuItem: 'usersUserManager',
                activeMenu: 'users',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" User Manager ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) => sub_module_action === 'TotalPoints'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('usersTotalPoints'),
            },attrs:{"to":{
              name: 'AdminUsersTotalPoints',
              params: {
                activeMenuItem: 'usersTotalPoints',
                activeMenu: 'users',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Total Points ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'BatchUserUploadTool'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('usersBatchUserUploadTool'),
            },attrs:{"to":{
              name: 'AdminBatchUserUploadTool',
              params: {
                activeMenuItem: 'usersBatchUserUploadTool',
                activeMenu: 'users',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Batch User-Upload Tool ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'BatchUserCreateTool'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('usersBatchUserCreateTool'),
            },attrs:{"to":{
              name: 'AdminBatchUserCreateTool',
              params: {
                activeMenuItem: 'usersBatchUserCreateTool',
                activeMenu: 'users',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Batch User-Create Tool ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'BatchPointUploadTool'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('usersBatchPointUploadTool'),
            },attrs:{"to":{
              name: 'AdminBatchPointUploadTool',
              params: {
                activeMenuItem: 'usersBatchPointUploadTool',
                activeMenu: 'users',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Batch Point-Upload Tool ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'SendEmailtoUsers'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('usersSendEmailToUsers'),
            },attrs:{"to":{
              name: 'AdminSendEmailToUser',
              params: {
                activeMenuItem: 'usersSendEmailToUsers',
                activeMenu: 'users',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Send Email to Users ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) => sub_module_action === 'AddPoints'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{ activeItem: _vm.isMenuItemMatched('usersAddPoints') },attrs:{"to":{
              name: 'AdminAddPointsSelectPrograms',
              params: {
                activeMenuItem: 'usersAddPoints',
                activeMenu: 'users',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Add Points ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'PointPrograms'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('usersPointPrograms'),
            },attrs:{"to":{
              name: 'AdminPointPrograms',
              params: {
                activeMenuItem: 'usersPointPrograms',
                activeMenu: 'users',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Point Programs ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'GenerateLibertyTaxationReport'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('usersUpdate'),
            },attrs:{"to":{
              name: 'UsersUpdate',
              params: {
                activeMenuItem: 'usersUpdate',
                activeMenu: 'users',
              },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Users Update ")],1):_vm._e()],1)],1):_vm._e(),(
          _vm.sidebarModules.some(
            ({ module_action }) => module_action === 'COMMUNICATION'
          )
        )?_c('li',[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle.communication",modifiers:{"communication":true}}],staticClass:"nav-link",attrs:{"href":"#communication #top"}},[_vm._v(" Communication ")]),_c('b-collapse',{attrs:{"id":"communication","accordion":"my-accordion","role":"tabpanel","visible":_vm.isMenuMatched('communication')}},[(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) => sub_module_action === 'ClientBlogs'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('communicationClientBlogs'),
            },attrs:{"to":{
              name: 'ClientBlogs',
              params: { activeMenuItem: 'communicationClientBlogs' },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Client Blogs ")],1):_vm._e()],1)],1):_vm._e(),(
          _vm.sidebarModules.some(
            ({ module_action }) => module_action === 'SETTINGS'
          )
        )?_c('li',[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle.settings",modifiers:{"settings":true}}],staticClass:"nav-link",attrs:{"href":"#settings #top"}},[_vm._v(" Settings ")]),_c('b-collapse',{attrs:{"id":"settings","accordion":"my-accordion","role":"tabpanel","visible":_vm.isMenuMatched('settings')}},[(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'RolesandPermissions'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('rolesAndPermissions'),
            },attrs:{"to":{
              name: 'AdminSettingsRoleAndPermissions',
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Roles and Permissions ")],1):_vm._e(),(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) => sub_module_action === 'Modules'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('modules'),
            },attrs:{"to":{
              name: 'AdminSettingsModules',
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Modules ")],1):_vm._e()],1)],1):_vm._e(),(
          _vm.sidebarModules.some(
            ({ module_action }) => module_action === '1TIMEPAYMENT'
          )
        )?_c('li',[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle.1TimePayment",modifiers:{"1TimePayment":true}}],staticClass:"nav-link",attrs:{"href":"#1TimePayment #top"}},[_vm._v(" One Time Payment ")]),_c('b-collapse',{attrs:{"id":"1TimePayment","accordion":"my-accordion","role":"tabpanel","visible":_vm.isMenuMatched('1TimePayment')}},[(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) => sub_module_action === 'Prefunding'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('prefunding'),
            },attrs:{"to":{
              name: 'Payment',
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Prefunding ")],1):_vm._e()],1)],1):_vm._e(),(
          _vm.sidebarModules.some(
            ({ module_action }) => module_action === 'RECOGNITION'
          )
        )?_c('li',[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle.recognition",modifiers:{"recognition":true}}],staticClass:"nav-link",attrs:{"href":"#recognition #top"}},[_vm._v(" Recognition ")]),_c('b-collapse',{attrs:{"id":"recognition","accordion":"my-accordion","role":"tabpanel","visible":_vm.isMenuMatched('recognition')}},[(
              _vm.sidebarSubModules.some(
                ({ sub_module_action }) =>
                  sub_module_action === 'ChallengesConfiguration'
              )
            )?_c('router-link',{staticClass:"nav-link",class:{
              activeItem: _vm.isMenuItemMatched('recognitionChallenges'),
            },attrs:{"to":{
              name: 'RecognitionChallenges',
              params: { activeMenuItem: 'recognitionChallenges' },
            }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"mr-1 ml-2",attrs:{"icon":"angle-right","transform":"shrink-1"}}),_vm._v(" Recognition Configuration ")],1):_vm._e()],1)],1):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }